/*
  Podcast episode row (sections/vbrntt-podcast.liquid, 2026-11-02). Each card is a link to the video on YouTube; here a
  plain click plays that episode in the player above instead (the playlist stays bound, autoplay on), marks the card
  as playing, and brings the player into view. Ctrl/Cmd/Shift/middle clicks keep the link's own behaviour.
  Four cards show at rest; the rest sit behind a "Show all" button. Without this script every card shows and every
  card opens YouTube.
*/
(() => {
  const VISIBLE = 4;
  document.querySelectorAll('[data-episodes]').forEach((row) => {
    const section = row.closest('section') || document;
    const player = section.querySelector('[data-episode-player]');
    const list = row.dataset.list || '';
    const cards = [...row.querySelectorAll('.vbrntt-podcast__episode')];

    if (player) {
      row.addEventListener('click', (event) => {
        const link = event.target.closest('[data-video-id]');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const id = encodeURIComponent(link.dataset.videoId);
        player.src = `https://www.youtube-nocookie.com/embed/${id}?list=${encodeURIComponent(list)}&autoplay=1`;
        row.querySelectorAll('[data-video-id][aria-current]').forEach((a) => a.removeAttribute('aria-current'));
        link.setAttribute('aria-current', 'true');
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        player.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      });
    }

    if (cards.length > VISIBLE) {
      const extra = cards.slice(VISIBLE);
      const more = row.dataset.showAll || 'Show all episodes';
      const less = row.dataset.showLess || 'Show fewer';
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'vbrntt-podcast__episodes-toggle';
      button.setAttribute('aria-expanded', 'false');
      const set = (open) => {
        extra.forEach((li) => { li.hidden = !open; });
        button.setAttribute('aria-expanded', String(open));
        button.textContent = open ? less : `${more} (${cards.length})`;
      };
      button.addEventListener('click', () => {
        const open = button.getAttribute('aria-expanded') !== 'true';
        set(open);
        if (open) extra[0].querySelector('a')?.focus();
      });
      set(false);
      row.append(button);
    }
  });
})();
